// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    getMasterAccounts,
    MasterAccountsCollectionModel,
    MasterAccountsParameter,
} from "@ces/App/Services/MasterAccountsService";
import { ApiHandler, createHandlerChainRunner, HasOnComplete } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<MasterAccountsParameter, MasterAccountsCollectionModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getMasterAccounts(props.apiParameter);
    } catch (error) {
        return error.errorMessage;
    }
};

export const DispatchCompleteLoadMasterAccounts: HandlerType = (props: any) => {
    props.dispatch({
        type: "xMasterAccounts/CompleteLoadShopAccounts",
        accounts: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadMasterAccounts];

const loadMasterAccounts = createHandlerChainRunner(chain, "LoadMasterAccounts");
export default loadMasterAccounts;
